import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';

import { providerActions } from '../../../../store';
import { useProviderDetailsState } from './useProviderDetailsState';

import type { AppDispatch } from '../../../../store';

export function useResetProviderPassword() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { provider } = useProviderDetailsState();
  const [cannotSendInvitePopup, setCannotSendInvitePopup] = useState(false);

  const resetProviderPassword = async () => {
    if (!provider?.email) {
      setCannotSendInvitePopup(true);
      return;
    }
    const { error } = await dispatch(
      providerActions.resetProviderPassword({
        getAccessTokenSilently,
        providerId: provider.id,
      }),
    );
    if (error) {
      toast.error(error?.message);
    } else {
      toast.success('Reset password email sent successfully to ' + provider.email, {
        toastId: 'provider-actions-id-invite-sent-successfully',
      });
    }
  };

  const closeCannotSendInvitePopup = () => {
    setCannotSendInvitePopup(false);
  };

  return {
    cannotSendInvitePopup,
    resetProviderPassword,
    closeCannotSendInvitePopup,
  };
}
